import LocalStorageState from "../../LocalStorage";
import {LOGIN_STATE} from "../constants";


export default function (state, action){

    if( action.payload === LOGIN_STATE.LOGGED_IN || action.payload === LOGIN_STATE.NOT_LOGGED ) {
        let loc = new LocalStorageState();
        loc.store({api: {loggedIn: action.payload}});
    }
    return {...state, loggedIn: action.payload};

}


// WEBPACK FOOTER //
// ./src/App/services/Api/reducers/login.js